import { useState, useRef, useEffect } from 'react';
import { visibility, uaParser } from '@betgames/bg-tools';
import { refreshIframe } from '@bg-shared/utils/refreshIframe';

const RELOAD_THRESHOLD = 5 * 60 * 1000; // 5 minutes;

export const useInactivity = (): boolean => {
    const [isInactive, setInactive] = useState<boolean>(false);
    const hiddenAt = useRef<number>(0);

    useEffect(() => {
        let timeout: number;

        visibility.setEvent((hidden) => {
            if (hidden) {
                // TODO: only experiment
                // https://javascript.plainenglish.io/inactive-tab-throttling-in-browsers-8aad673ab86d#:~:text=Inactive%20tab%20throttling%20is%20a%20form%20of%20resource%20management.,tab%20throttling%20improves%20user%20experience.
                // suggestion to use WS for autoplay
                // webSockets events handlers are not throttled

                hiddenAt.current = Date.now();

                if (uaParser.isMobile) {
                    setInactive(true);
                } else {
                    timeout = setTimeout(() => {
                        setInactive(true);
                    }, 30000);
                }
            } else {
                clearTimeout(timeout);
                const isAwayTooLong = Date.now() - hiddenAt.current > RELOAD_THRESHOLD;

                if (isAwayTooLong) {
                    refreshIframe();
                } else {
                    hiddenAt.current = 0;
                    setInactive(false);
                }
            }
        });

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return isInactive;
};
